export default function About() {
  return (
    <section id="sobre" className="py-8 md:py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-6 md:mb-16">
          <h2 className="text-2xl md:text-5xl font-bold text-green-800 mb-3">Sobre a Agubel</h2>
          <div className="w-20 h-1 bg-amber-500 mx-auto"></div>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center max-w-6xl mx-auto">
          <div>
            <img
              src="https://static.readdy.ai/image/7511a7cc259ce621d354b0ff71fdfe7c/9225a7ba2f21c790a127f5e64eb0d1bc.jpeg"
              alt="Usina de Beneficiamento Agubel"
              className="rounded-lg shadow-xl w-full h-64 md:h-96 object-cover object-top"
            />
          </div>
          
          <div className="space-y-4 md:space-y-6">
            <p className="text-sm md:text-lg text-gray-700 leading-relaxed">
              A <strong>Agubel</strong> foi fundada em 2004 e está localizada na zona rural de Sumé, Paraíba. A associação gerencia a Usina de Beneficiamento de Lácteos e atua com o beneficiamento e distribuição do leite de cabra, além da produção de derivados lácteos.
            </p>
            
            <p className="text-sm md:text-lg text-gray-700 leading-relaxed">
              Trabalhamos em parceria com diversas associações de produtores e criadores de cabras do Cariri paraibano, beneficiando aproximadamente <strong>150 famílias</strong> de agricultores familiares.
            </p>
            
            <p className="text-sm md:text-lg text-gray-700 leading-relaxed">
              O laticínio possui registro no <strong>Serviço de Inspeção Federal (SIF)</strong>, garantindo qualidade, segurança e possibilidade de comercialização nacional e internacional.
            </p>
            
            <div className="bg-green-50 p-4 md:p-6 rounded-lg border-l-4 border-green-600">
              <p className="text-sm md:text-lg text-gray-800 italic">
                "Cada produto carrega uma história — a história das famílias que produzem, da terra que sustenta e da tradição que preserva."
              </p>
            </div>
          </div>
        </div>
        
        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mt-8 md:mt-16 max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-green-50 to-green-100 p-5 md:p-8 rounded-lg text-center shadow-md">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-flag-line text-xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-base md:text-xl font-bold text-green-800 mb-2">Missão</h3>
            <p className="text-xs md:text-base text-gray-700">
              Fortalecer a caprinocultura leiteira no Cariri paraibano, valorizando o cooperativismo e a agricultura familiar, oferecendo produtos nutritivos, sustentáveis e de alta qualidade.
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-amber-50 to-amber-100 p-5 md:p-8 rounded-lg text-center shadow-md">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-amber-600 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-eye-line text-xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-base md:text-xl font-bold text-amber-800 mb-2">Visão</h3>
            <p className="text-xs md:text-base text-gray-700">
              Tornar-se referência nacional na produção de leite de cabra e derivados, destacando-se pela excelência, inovação e impacto social.
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-green-50 to-green-100 p-5 md:p-8 rounded-lg text-center shadow-md">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-heart-line text-xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-base md:text-xl font-bold text-green-800 mb-2">Valores</h3>
            <p className="text-xs md:text-base text-gray-700">
              Tradição, qualidade, sustentabilidade, cooperação e desenvolvimento regional.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
